import { apiGet } from '../axios.config'
import { API_ROUTES } from '../routes'
import { AgreemenetType } from '../typing'
import { useQueryHook } from './queryHook'

interface IResponse {
  items: AgreemenetType[]
}

export const useGetDictionaryAgreementTypes = () => {
  const path = API_ROUTES.DICTIONARY_AGREEMENT_TYPES

  const queryObject = useQueryHook({
    key: [path],
    fetcherFunction: async () => {
      const { data } = await apiGet<object, IResponse>({ path })

      return data
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
